import { Injectable } from '@angular/core';
import { ToasterService } from 'angular2-toaster';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  constructor(private toasterService: ToasterService) {}

  showSuccess(header: any, description: any) {
    this.toasterService.pop(`success`, header, description);
  }

  showError(header: any, description: any) {
    this.toasterService.pop(`error`, header, description);
  }

  showWarning(header: any, description: any) {
    this.toasterService.pop(`warning`, header, description);
  }

  showInfo(header: any, description: any) {
    this.toasterService.pop(`info`, header, description);
  }
}
